import { createAsyncThunk } from '@reduxjs/toolkit'
import axios, { AxiosError, AxiosResponse } from 'axios'
import { API_URL_FELL } from 'config'
import { ServerSettingsData } from 'lib/types'

export type ServerSettingsnUpdatePayload = {
  data?: ServerSettingsData
  projectId: number
  siteId: number
  siteDesignId: number
  error?: string
  status?
}

export const putServerSettings = createAsyncThunk<
  ServerSettingsnUpdatePayload,
  { projectId: number; siteId: number; siteDesignId: number; serverSettings: ServerSettingsData; dispatch },
  { rejectValue: ServerSettingsnUpdatePayload }
>('serverSettings/putServerSettings', async (args, { rejectWithValue }) => {
  try {
    const apiResponse = await axios.put<ServerSettingsData>(`${API_URL_FELL()}/project/${args.projectId}/site/${args.siteId}/sitedesign/${args.siteDesignId}/serversettings`, args.serverSettings)
    return {
      data: apiResponse.data,
      projectId: args.projectId,
      siteId: args.siteId,
      siteDesignId: args.siteDesignId
    }
  } catch (err) {
    const error: AxiosError<string> = err
    return rejectWithValue({
      error: error.message,
      projectId: args.projectId,
      siteId: args.siteId,
      siteDesignId: args.siteDesignId
    })
  }
})

export const getRestoreDefaultServerSettings = createAsyncThunk<AxiosResponse<{}>, void, { rejectValue: string }>('serverSettings/getRestoreDefaultServerSettings', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL_FELL()}/defaults`)
    return response.data
  } catch (err) {
    let error: AxiosError<string> = err
    return rejectWithValue(error.response.data)
  }
})
